<template>
  <div class="componentWrapper" @click="listenOut">

    <div id="service" :class="'grid grid__item_span-12 p0 m0 project-' + page.colorTheme">

      <!-- add the project header -->
      <ProjectHeader v-if="page.pageType !== 'service'" v-bind:page="page"></ProjectHeader>
      <ServiceHeader v-else v-bind:page="page"></ServiceHeader>
      <!-- end -->

      <!-- Project Content Wrapper  -->
      <div id="projectContent">

        <!-- lets add in some components -->

        <div v-for="item in page.contentAreas" class="grid grid__item_span-12 p0 m0">
          <div v-for="(item, index) in item.type" class="grid grid__item_span-12 p0 m0">

            <div v-if="item.acf_fc_layout === 'component_paragraph'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.paragraph_bkgd_colour + '; padding:' + item.paragraph_v1_padding + ';'">
               <Paragraph :id="'sec-' + index" :item="item" :class="projectType" ></Paragraph>
            </div>

            <div v-if="item.acf_fc_layout === 'component_paragraph_v2'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.paragraph_v2_bkgd_colour + '; padding:' + item.paragraph_v2_padding + ';'">
               <Paragraph2 :id="'sec-' + index" :item="item" :class="projectType" ></Paragraph2>
            </div>

            <div v-if="item.acf_fc_layout === 'component_paragraph_v3'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.paragraph_v3_bkgd_colour + '; padding:' + item.paragraph_v3_padding + ';'">
               <Paragraph3 :id="'sec-' + index" :item="item" :class="projectType" ></Paragraph3>
            </div>

            <div v-if="item.acf_fc_layout === 'component_badge'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.project_badge_background_color + ';'">
              <Badge :id="'sec-' + index" :item="item"></Badge>
            </div>

            <div v-if="item.acf_fc_layout === 'component_headline'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.headline_bkgd_colour + '; padding:' + item.headline_padding + ';'">
              <Headline :id="'sec-' + index" :item="item"></Headline>
            </div>

            <div v-if="item.acf_fc_layout === 'component_double_image'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.double_image_bkgd_colour + '; padding:' + item.double_image_padding + ';'">
              <DoubleImage :id="'sec-' + index" :item="item"></DoubleImage>
            </div>

            <div v-if="item.acf_fc_layout === 'component_single_image'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.single_image_bkgd_colour + '; padding:' + item.single_image_padding + ';'">
              <SingleImage :id="'sec-' + index" :item="item"></SingleImage>
            </div>

            <div v-if="item.acf_fc_layout === 'component_video'" class="grid grid__item_span-12 p0 m0" :class="projectType" :style="'background:' + item.video_bkgd_colour + '; padding:' + item.video_padding + ';'">
              <PageVideo :id="'sec-' + index" :item="item"></PageVideo>
            </div>

            <div v-if="item.acf_fc_layout === 'component_image_slider'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.slider_bkgd_colour + '; padding:' + item.image_slider_padding + ';'">
              <ImageSlider :id="'sec-' + index" :item="item, index"></ImageSlider>
            </div>

            <div v-if="item.acf_fc_layout === 'component_quote'" class="grid grid__item_span-12 p0 m0" :style="'background:' + item.quote_bkgd_colour + '; padding:' + item.quote_padding + ';'">
              <Quote :id="'sec-' + index" :item="item"></Quote>
            </div>

          </div>
        </div>
        <!-- end of components -->

      </div>

    </div>

    <!-- <div id="casestudyFooter" class="grid grid__item_span-12 p0 m0" v-in-viewport>
      <div class="inner grid grid__item_span-9" v-for="(item, index) in siblings" v-if="nextPageLink === item.pageLink" :id="item.pageID">
        <p class="txtWhite grid grid__item_span-12 m0 p0">Can't get enough?</p>
        <h2 class="txtWhite grid grid__item_span-12 m0 p0">{{item.pageTitle}}</h2>
        <router-link :to="item.pageLink"><p class="txtWhite grid grid__item_span-12 m0 p0">View case study</p></router-link>
      </div>
    </div> -->

    <div id="footer-sec" class="grid grid__item_span-12 p0 m0" :attr="page.serviceTitle" style="margin-top: -1px; position: relative;">
      <div class="g-partnersbadge" data-agency-id="3960940047"></div>
        <!-- Add the code snippet above to the sites listed to display your badge:
              http://blacksheepdesign.co.nz -->

      <div class="inner grid grid__item_span-12 m0 p0" v-for="(item, index) in siblings" v-if="nextPageLink === item.slug.url">
        <ProjectFooter v-if="page.pageType !== 'service'" :item="item"></ProjectFooter>
        <ServiceFooter v-else :item="item"></ServiceFooter>
      </div>
    </div>

  </div>

</template>

<script>

import menuTransitions from '../assets/js/menu.js'
import ProjectHeader from '../components/project/proj_header.vue'
import ServiceHeader from '../components/project/serv_header.vue'
import ProjectFooter from '../components/project/projectFooter.vue'
import ServiceFooter from '../components/project/serv_Footer.vue'
import Headline from '../components/project/headline.vue'
import Quote from '../components/project/quote.vue'
import Paragraph from '../components/project/paragraph.vue'
import Paragraph2 from '../components/project/paragraph2.vue'
import Paragraph3 from '../components/project/paragraph3.vue'
import SingleImage from '../components/project/singleImage.vue'
import Badge from '../components/project/badge.vue'
import PageVideo from '../components/project/video.vue'
import DoubleImage from '../components/project/doubleImage.vue'
import ImageSlider from '../components/project/imageSlider.vue'
import animateScrollTo from 'animated-scroll-to'
import Axios from 'axios'

export default {
  name: 'Service',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      logoColour: 'black',
      metaTitle: '',
      metaDescription: '',
      page: {},
      siblings: [],
      nav: [],
      nextPageLink: '',
      projectType: ''
    }
  },
  metaInfo () {
    return {
      title: this.metaTitle,
      meta: [
        { name: 'description', content: this.metaDescription }
      ]
    }
  },
  computed: {
    findLogoColour: function () {
      // request the logo colour
      this.$bus.$emit('bsdLogo', {bsdColour: this.logoColour})
      // return this.logoColour
    }
  },
  methods: {
    getData () {
      Axios.get(this.$root.$data.site + '/wp-json/wp/v2/services/').then(response => {
        var siblings = response.data.map(obj => {
          return {
            pageID: obj.id,
            pageTitle: obj.acf.project_title,
            pageClient: obj.acf.client_name,
            cta: obj.acf.project_cta,
            slug: {
              name: 'Project',
              url: obj.slug,
              id: obj.id
            }
          }
        })
        siblings.forEach(el => {
          this.siblings.push(el)
        })

        var nav = response.data.map(obj => obj.slug)

        nav.forEach(el => {
          this.nav.push(el)
        })

        this.nextPage()
      }).catch(function (error) {
        console.log(error)
      })

      Axios.get(this.$root.$data.site + '/wp-json/wp/v2/services/?slug=' + this.$route.params.slug).then(response => {
        this.metaTitle = response.data[0].acf.meta_title
        this.metaDescription = response.data[0].acf.meta_description
        this.logoColour = response.data[0].acf.bsd_logo_colour
        this.projectType = response.data[0].acf.project_type
        this.postID = response.data[0].id
        var page = {
          serviceTitle: response.data[0].title.rendered,
          colorTheme: response.data[0].acf.colour_theme,
          pageType: response.data[0].acf.project_type,
          textColor: response.data[0].acf.header_text_colour,
          backgroundColor: response.data[0].acf.beackground_colour_header,
          contentAreas: response.data[0].acf.project_layout.length > 0 ? response.data[0].acf.project_layout.map(obj => {
            return {
              type: obj.components
            }
          }) : null
        }

        this.page = page
      }).catch(function (error) {
        console.log(error)
      })
    },
    scrollTo (destination) { // scroll to a div position
      setTimeout(function () {
        var destinationWrap = document.getElementById(destination)
        const options = {
          speed: 1900
        }
        animateScrollTo(destinationWrap, options)
      }, 200)
    },
    listenOut () { // this is the function which closes the menu
      menuTransitions.hideHeader()
    },
    nextPage () {
      // this.navigationDirection = 'forward'
      // console.log(this.nav)
      // console.log(this.$route.params.slug)
      var navLength = this.nav.length - 1
      var currentSlug = this.$route.params.slug
      var nextPage = ''
      var currentPage = this.nav.indexOf(currentSlug)
      if (currentPage === navLength) {
        nextPage = this.nav[0]
      } else {
        nextPage = this.nav[currentPage + 1]
      }
      // console.log(nextPage)
      this.nextPageLink = nextPage
      // if (nextPage) { this.$router.push(nextPage) }
    }
    /* scroller () {
      var d = document.documentElement
      var offset = d.scrollTop + window.innerHeight
      var height = d.offsetHeight - 0.5
      var footerTop = document.getElementById('casestudyFooter').offsetTop - 1
      console.log(footerTop)
      console.log(offset + ', ' + height)
      // if (offset === height || offset >= height) {
      if (footerTop === offset || offset >= footerTop) {
        console.log('at the bottom')
        // this.nextPage()
        // document.getElementById('casestudyFooter').style.position = 'fixed'
        // document.getElementById('casestudyFooter').classList.add('openUp')
      } if (offset <= footerTop) {
        // document.getElementById('casestudyFooter').style.position = 'absolute'
        // document.getElementById('casestudyFooter').classList.remove('openUp')
      }
    } */
  },
  mounted () {
    // Hide the bsdText div until we scroll
    document.getElementById('bsdIcon').style.opacity = 1
    document.getElementById('bsdText').style.opacity = 0

    setTimeout(function () {
      if (document.getElementById('contactClick')) {
        document.getElementById('contactClick').addEventListener('click', function () {
          setTimeout(function () {
            var destinationWrap = document.getElementById('footer-sec')
            const options = {
              speed: 1900
            }
            animateScrollTo(destinationWrap, options)
          }, 200)
        })
      }
    }, 500)
  },
  created () {
    this.getData()
  },
  components: {
    ProjectHeader,
    ServiceHeader,
    ServiceFooter,
    ProjectFooter,
    Headline,
    Quote,
    Paragraph,
    Paragraph2,
    Paragraph3,
    SingleImage,
    DoubleImage,
    ImageSlider,
    PageVideo,
    Badge
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .componentWrapper{
    /* padding: 15vh 0; */
    /* background: #EFF0F1; */
  }

</style>



// WEBPACK FOOTER //
// src/components/service.vue